import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LIBRARY_TRANSLATIONS, flattenTranslations } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})

/* This code defines an Angular code that is used to load translations from a JSON() 
file and dynamically extract translations based on the selected language. It is part of the integration with the module */
export class CustomTranslateLoader implements TranslateLoader {
  private translationsUrl = 'assets/i18n/translations.json';

  constructor(private http: HttpClient) {
    // Al iniciar, establecer el idioma guardado si existe
    const savedLang = localStorage.getItem('app_lang');
    if (savedLang) {
      // ngx-translate no se inicializa aquí, pero puedes usar este valor en el módulo principal
    }
  }

  getTranslation(lang: string): Observable<Record<string, string>> {
    // Guardar el idioma cada vez que se solicita una traducción
    localStorage.setItem('app_lang', lang);
    return this.http.get<Record<string, Record<string, string>>>(this.translationsUrl).pipe(
      map((translations) => {
        const extractedTranslations: Record<string, string> = {};
        Object.keys(translations).forEach((key) => {
          if (translations[key][lang]) {
            extractedTranslations[key] = translations[key][lang];
          }
        });
        // App translations win over the library's own (filters panel, nav menu…) when a key exists in both.
        return { ...(flattenTranslations(LIBRARY_TRANSLATIONS, lang) as Record<string, string>), ...extractedTranslations };
      }),
    );
  }
}
